import LottoOdd from '@core/models/lotto/LottoOdd';
import Decimal from 'decimal.js-light';
import { calcCombs, localeNumberFormat } from './math';
import { range as _range } from '@lodash';

const ZERO = new Decimal(0);

export const findOdd = (odds: any[], index: number) => odds
    .find((odd: any) => odd.order === index);

export const calcWinForBall = (
    index: number,
    selectedSystem: number,
    odds: any[]
): Decimal => {
    const calculatedCombs = new Decimal(calcCombs(index, selectedSystem));
    const oddForSystem = new Decimal(findOdd(odds, selectedSystem).value);
    return calculatedCombs.greaterThan(ZERO)
     ? calculatedCombs.mul(oddForSystem)
     : ZERO.mul(oddForSystem);
};

// TODO: replace with lib implementation
export const prepareLottoWinByBall = (
    numbersDrawn: number,
    total: Decimal,
    handlingFee: Decimal,
    maxWin: Decimal,
    combCount: Decimal,
    system: any,
    odds: LottoOdd[],
) => {
    // stake after applying handling fee
    const stake = total.mul(100).dividedBy(handlingFee.plus(100));
    // stake per total amount of combinations
    const stakePerComb = stake.dividedBy(combCount).toDecimalPlaces(8);
    // list of systems selected e.g. 1,3,5/8 numbers before '/8'
    const selectedSystems = system.selected;
    // number of events (lotto balls)
    const systemCount = system.count;
    /**
     * chooses upper ball range,
     * e.g. if user chooses more numbers than drawn in a game, games numbers are the limit
     */
    const upperBallRange = systemCount > numbersDrawn ? numbersDrawn : systemCount;

    const systemBallRange = _range(Math.min(...selectedSystems), upperBallRange + 1);
    return systemBallRange.map((ballNo: number) => {
        const winPerBallSum = selectedSystems.map((selectedSystem: number) => calcWinForBall(
                ballNo,
                selectedSystem,
                odds,
            ))
            .reduce((a: Decimal, b: Decimal) => a.plus(b)).mul(stakePerComb);
        const limitedWinPerBall = winPerBallSum.greaterThan(maxWin) ? maxWin : winPerBallSum;
        return (limitedWinPerBall.greaterThan(ZERO))
            ? ({ ball: ballNo, value: localeNumberFormat(limitedWinPerBall.toNumber()) })
            : undefined;
    })
    .filter((winPerBall: any) => !!winPerBall);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/core/services/gravity/helpers/lotto.ts